import React, { Component } from "react";
import { Icon, Modal, Button } from "antd";
import { Translate } from "react-translated";

class ConfirmationModal extends Component {
  render() {
    return (
      <div style={{ marginBottom: 20 }}>
        <Modal
          title={this.props.title}
          visible={this.props.showModal}
          onOk={this.props.ok}
          onCancel={this.props.cancel}
          okText={this.props.okText}
          cancelText={this.props.cancelText}
          maskClosable={false}
          closable={false}
          okButtonProps={{ className: 'borderRadius-28 bg-164897' }}
          cancelButtonProps={{ className: 'borderRadius-28' }}
        >
          <div>
            <p>{this.props.message}</p>
          </div>
        </Modal>
      </div>
    );
  }
}

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/confirmation-modal.js